import logo from '../asset/logo.svg';
import cart from '../asset/cart-icon.svg';
import food from '../asset/food.svg';
import backarrow from '../asset/back-arrowbtn.svg';
import ellipse from '../asset/Ellipse.svg';
import thumb_nail from '../asset/Home/Thumbnail.png';
import cartWheel from '../asset/cart-wheels.svg';
const image = {
  logo,
  cart,
  food,
  backarrow,
  ellipse,
  thumb_nail,
  cartWheel,
};
export default image;
